/* =========================================================
   Affiche GOLF « La carte » — deux lectures d'un même parcours.
   API : SNGolfCarte.render(data, opts) -> string SVG
     data : { mode, parcours, lieu, date, joueur, titre,
              p1..p18  (par de chaque trou),
              s1..s18  (votre score sur chaque trou) }
       mode : 'carte'  → la grille 18 trous, notation officielle
              'trous'  → un drapeau par trou, allumé sous le par
     opts : { palette }
   Le total, l'écart au par et les compteurs de birdies sont CALCULÉS.
   Auto-suffisant → re-render serveur direct pour l'impression.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 64;

  const PALETTES = {
    craie: { label: 'Craie', bg:'#F7F4ED', ink:'#0B2D5B', muted:'#8B94A3', accent:'#FF6B2C', line:'#E3DDD0', card:'#FFFFFF', deep:'#DFE7DF' },
    green: { label: 'Gazon', bg:'#0E3B2E', ink:'#F4F1E8', muted:'#8FB3A5', accent:'#FF6B2C', line:'#1C5544', card:'#134536', deep:'#0A2E23' },
    nuit:  { label: 'Nuit',  bg:'#0B2D5B', ink:'#F7F4ED', muted:'#93A1B8', accent:'#FF9E5C', line:'#1E4272', card:'#12355F', deep:'#082444' },
    sable: { label: 'Sable', bg:'#EDE3D2', ink:'#2C3A2E', muted:'#8A8676', accent:'#C4622D', line:'#DDD0B9', card:'#F7F1E6', deep:'#DCCFB6' },
  };

  const esc = s => String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  const up = s => String(s == null ? '' : s).toUpperCase();
  const num = s => { const m = String(s == null ? '' : s).match(/-?\d+/); return m ? parseInt(m[0], 10) : null; };
  const fit = (t, maxW, maxS, cwf, ls, minS) => { const n = String(t).length || 1; minS = minS || 12;
    for (let s = maxS; s > minS; s -= 1) if (n * (cwf * s + ls) <= maxW) return s; return minS; };
  const T = (x,y,size,fill,txt,o) => { o = o || {};
    return `<text x="${x}" y="${y}" font-family="${o.f||'Sora'}" font-size="${size}" font-weight="${o.w||600}" fill="${fill}"`
      + (o.ls?` letter-spacing="${o.ls}"`:'') + ` text-anchor="${o.a||'middle'}"`
      + (o.op?` opacity="${o.op}"`:'') + `>${txt}</text>`; };

  /* Notation officielle : birdie entouré, eagle double cercle,
     bogey encadré, double bogey double carré. */
  function marque(x, y, s, type, col) {
    if (type === 'birdie') return `<circle cx="${x}" cy="${y}" r="${s}" fill="none" stroke="${col}" stroke-width="2.2"/>`;
    if (type === 'eagle')  return `<circle cx="${x}" cy="${y}" r="${s}" fill="none" stroke="${col}" stroke-width="2.2"/><circle cx="${x}" cy="${y}" r="${s*0.72}" fill="none" stroke="${col}" stroke-width="2.2"/>`;
    if (type === 'bogey')  return `<rect x="${x-s}" y="${y-s}" width="${s*2}" height="${s*2}" fill="none" stroke="${col}" stroke-width="2.2"/>`;
    if (type === 'double') return `<rect x="${x-s}" y="${y-s}" width="${s*2}" height="${s*2}" fill="none" stroke="${col}" stroke-width="2.2"/><rect x="${x-s*0.72}" y="${y-s*0.72}" width="${s*1.44}" height="${s*1.44}" fill="none" stroke="${col}" stroke-width="2.2"/>`;
    return '';
  }
  const typeDe = d => d <= -2 ? 'eagle' : d === -1 ? 'birdie' : d === 1 ? 'bogey' : d >= 2 ? 'double' : '';

  function flag(cx, baseY, h, p, col, sansTrou) {
    const top = baseY - h;
    return (sansTrou ? '' : `<ellipse cx="${cx}" cy="${baseY}" rx="${h*0.16}" ry="${h*0.05}" fill="${p.deep}" opacity="0.55"/><circle cx="${cx}" cy="${baseY}" r="${h*0.075}" fill="${p.deep}"/>`)
      + `<rect x="${cx-h*0.012}" y="${top}" width="${h*0.024}" height="${h}" rx="${h*0.012}" fill="${p.ink}"/>`
      + `<path d="M${cx+h*0.012} ${top+h*0.02} L${cx+h*0.30} ${top+h*0.105} L${cx+h*0.012} ${top+h*0.19} Z" fill="${col||p.accent}"/>`;
  }

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.craie;
    const mode = String(data.mode || 'carte').toLowerCase();
    const cx = PW / 2;

    /* Trous : par (défaut 4) et score saisi. Un trou sans score reste vide. */
    const trous = [];
    for (let i = 1; i <= 18; i++) {
      trous.push({ n: i, par: num(data['p' + i]) != null ? num(data['p' + i]) : 4, sc: num(data['s' + i]) });
    }
    const joues = trous.filter(t => t.sc != null);
    const total = joues.reduce((a, t) => a + t.sc, 0);
    const parJoue = joues.reduce((a, t) => a + t.par, 0);
    const ecart = total - parJoue;
    const ecartTxt = joues.length ? (ecart === 0 ? 'PAR' : (ecart > 0 ? '+' : '') + ecart) : '';

    const titre = up(data.titre) || (mode === 'trous' ? 'MON PARCOURS' : 'MA MEILLEURE CARTE');
    const ts = fit(titre, 700, 74, 0.54, 2, 34);
    const sous = [up(data.lieu), up(data.date)].filter(Boolean).join(' · ');

    let corps = '';

    if (mode === 'trous') {
      /* Grille de 18 drapeaux, allumés quand le trou est sous le par. */
      for (let i = 0; i < 18; i++) {
        const t = trous[i], col = i % 6, row = Math.floor(i / 6);
        const x = 128 + col * 109, y = 336 + row * 186;
        const d = t.sc == null ? null : t.sc - t.par;
        const fc = d == null ? p.muted : d < 0 ? p.accent : d === 0 ? p.ink : p.muted;
        corps += `<circle cx="${x}" cy="${y}" r="48" fill="${p.card}" opacity="${d != null && d < 0 ? 1 : 0.5}"/>`
          + flag(x, y + 26, 74, p, fc)
          + T(x, y + 66, 11, p.muted, 'N° ' + t.n, { w:700, ls:1.5 })
          + T(x, y + 92, 24, fc, t.sc == null ? '—' : String(t.sc), { f:'Oswald', w:700 });
      }
      corps += `<rect x="${MX}" y="882" width="${PW-2*MX}" height="112" rx="14" fill="${p.card}"/>`
        + T(cx, 922, 14, p.accent, 'SCORE BRUT', { w:700, ls:7 })
        + `<text x="${cx}" y="976" text-anchor="middle" font-family="Oswald" font-weight="700" fill="${p.ink}"><tspan font-size="62">${joues.length ? total : '—'}</tspan>${ecartTxt ? `<tspan font-size="24" fill="${p.accent}" dx="8">${ecartTxt}</tspan>` : ''}</text>`;
    } else {
      /* Grille classique aller / retour, avec la notation officielle. */
      const larg = PW - 2 * MX, cw = larg / 9;
      [0, 1].forEach(bloc => {
        const yT = 330 + bloc * 250;
        const sousTotal = trous.slice(bloc*9, bloc*9+9).filter(t => t.sc != null).reduce((a,t) => a + t.sc, 0);
        corps += T(MX, yT - 26, 13, p.muted, bloc ? 'RETOUR' : 'ALLER', { w:700, ls:3, a:'start' })
          + (sousTotal ? T(PW-MX, yT - 26, 13, p.muted, sousTotal + ' COUPS', { w:700, ls:2, a:'end' }) : '')
          + `<rect x="${MX}" y="${yT-12}" width="${larg}" height="86" rx="8" fill="${p.card}" stroke="${p.line}" stroke-width="1.5"/>`;
        for (let i = 0; i < 9; i++) {
          const t = trous[bloc*9 + i], x = MX + cw*i + cw/2;
          if (i) corps += `<line x1="${(MX+cw*i).toFixed(1)}" y1="${yT-12}" x2="${(MX+cw*i).toFixed(1)}" y2="${yT+74}" stroke="${p.line}" stroke-width="1"/>`;
          corps += T(x, yT+8, 11, p.muted, String(t.n), { w:700, ls:1 })
            + T(x, yT+26, 10, p.muted, 'PAR ' + t.par, { w:600 });
          if (t.sc == null) { corps += T(x, yT+59, 24, p.muted, '—', { f:'Oswald', w:700, op:0.5 }); continue; }
          const d = t.sc - t.par, ty = typeDe(d), col = d < 0 ? p.accent : p.ink;
          if (ty) corps += marque(x, yT+52, 15, ty, col);
          corps += T(x, yT+59, 24, col, String(t.sc), { f:'Oswald', w:700 });
        }
      });
      corps += `<rect x="${MX}" y="708" width="${PW-2*MX}" height="140" rx="14" fill="${p.ink}"/>`
        + T(cx, 748, 15, p.accent, 'SCORE BRUT', { w:700, ls:7 })
        + `<text x="${cx}" y="828" text-anchor="middle" font-family="Oswald" font-weight="700" fill="${p.bg}"><tspan font-size="62">${joues.length ? total : '—'}</tspan>${ecartTxt ? `<tspan font-size="26" fill="${p.accent}" dx="10">${ecartTxt}</tspan>` : ''}</text>`
        + `<g opacity="0.9">`
        + T(150, 918, 12, p.muted, 'BIRDIE', { w:600, ls:2 }) + marque(150, 894, 12, 'birdie', p.accent)
        + T(320, 918, 12, p.muted, 'EAGLE', { w:600, ls:2 }) + marque(320, 894, 12, 'eagle', p.accent)
        + T(490, 918, 12, p.muted, 'BOGEY', { w:600, ls:2 }) + marque(490, 894, 12, 'bogey', p.ink)
        + T(655, 918, 12, p.muted, 'DOUBLE', { w:600, ls:2 }) + marque(655, 894, 12, 'double', p.ink)
        + `</g>`;
    }

    const piedY = mode === 'trous' ? 1032 : 1000;
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
${T(cx, 84, 19, p.accent, esc(up(data.parcours) || 'VOTRE PARCOURS'), { w:700, ls:5 })}
${T(cx, 168, ts, p.ink, esc(titre), { f:'Oswald', w:700, ls:2 })}
${sous ? T(cx, 204, 17, p.muted, esc(sous), { w:600, ls:3.5 }) : ''}
${corps}
${data.joueur ? T(cx, piedY, 19, p.ink, esc(up(data.joueur)), { f:'Oswald', w:700, ls:2 }) : ''}
</svg>`;
  }

  window.SNGolfCarte = { render, PALETTES };
})();
